import React from "react";
//#region types
import { EntityCardSkeletonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import TopCardSkeleton from "./topCardSkeleton";
import TitledContainerSkeleton from "./titledContainerSkeleton";
import AccordianPanelSkeleton from "../accordianPanelSkeleton";
import EntityCardContent from "../../pageLayouts/entityCardContent";
//#endregion

const EntityCardSkeleton: React.FC<EntityCardSkeletonProps> = (props) => {
  return (
    <EntityCardContent
      topTodoCard={<TopCardSkeleton />}
      todoMainSection={<TitledContainerSkeleton />}
      footer={<></>}
      infoViewer={props.hasInfoViewer ? <></> : undefined}
    >
      <AccordianPanelSkeleton />
    </EntityCardContent>
  );
};

export default EntityCardSkeleton;
